var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 0.00488281C3.58277 0.00488281 0.00500488 3.58265 0.00500488 7.99989C0.00500488 12.4171 3.58277 15.9949 8.00001 15.9949C12.4172 15.9949 15.995 12.4171 15.995 7.99989C15.995 3.58265 12.4172 0.00488281 8.00001 0.00488281ZM7.00063 12.9968V10.998H8.99938V12.9968H7.00063ZM7.00063 3.00301V9.99864H8.99938V3.00301H7.00063Z",
    fill: "#D14343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.db399fa7f2378d4c0d8909e527ca71de.svg";
export { ForwardRef as ReactComponent };